import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements AfterViewInit {
  marqueeItems = ['Used', 'in', '600+', 'real', 'projects', 'in', 'Tamil', 'Nadu.'];

  ngAfterViewInit(): void {
    // Initialize atropos if needed
    if (typeof (window as any).Atropos !== 'undefined') {
      const atroposElements = document.querySelectorAll('[data-atropos]');
      atroposElements.forEach((element: Element) => {
        new (window as any).Atropos({
          el: element
        });
      });
    }
  }
}

